export function search(state, query) {
  return {};
}
